import React, { useState } from "react";

const PayDuesModal = ({ show, balance, onClose, onConfirm }) => {
    const [amount, setAmount] = useState("");

    if (!show) return null;

    const handleSubmit = () => {
        if (!amount || isNaN(amount) || Number(amount) <= 0) {
            alert("Enter a valid amount");
            return;
        }
        if (Number(amount) > Math.abs(balance)) {
            alert("Amount cannot exceed outstanding balance");
            return;
        }
        onConfirm(Number(amount));
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md">
                {/* Header */}
                <div className="flex justify-between items-center p-4 border-b">
                    <h3 className="text-lg font-semibold">Pay Dues</h3>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        ✕
                    </button>
                </div>

                {/* Body */}
                <div className="p-4 space-y-3">
                    <p>
                        <strong>Outstanding Balance:</strong> ₹ {balance.toFixed(2)}
                    </p>
                    <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        className="w-full border rounded px-3 py-2"
                        placeholder="Enter amount to pay"
                    />
                </div>

                {/* Footer */}
                <div className="flex justify-end space-x-2 p-4 border-t">
                    <button
                        onClick={onClose}
                        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-colors"
                    >
                        Confirm Payment
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PayDuesModal;
